// Note: Change in there will need to refresh datawharehouse material views since this are the part of dwh columns
// example https://github.com/building-estimates/platform/commit/e9fb84be4148c6a15ea27c2cc2232986d640581b#diff-9c91d9464a27340682a2aa309969fd03deb14113e55d276dd415f925718889f7

export const ids = [
	'residentialDetached',
	'residentialAttached',
	'multiFamily',
	'commercial',
	'residentialAlteration',
	'commercialAlteration',
	'residentialSemiDetached', // [ROME-3373] UK
	'attic', // [ROME-3373] UK
	'tractBuild', // [ROME-5295] US
] as const;
